<template>
	<div class="spofaq-searchapp">
		<Spinner :active="status === 'searching'"></Spinner>
		<SearchForm
			v-on:input="getPosts"
			:placeholder="wpData.search_text"
			v-model="searchTerm"
		/>
		<!-- Search Results -->
		<div class="spofaq-searchapp__results">
			<Categories
				v-bind:categories="categories"
				:selectedCategory="spofaqSelectedCategory"
				:status="status"
				v-on:filter-categories="getPostsForCategory"
				v-if="spofaqPosts.length > 0"
			/>
			<div
				class="spofaq-searchapp__status"
				v-html="statusText"
				aria-live="polite"
			>
				{{ statusText }}
			</div>
			<Posts v-bind:posts="visiblePosts"></Posts>
			<a
				href="javascript:void(0);"
				class="spofaq-searchapp__more-link"
				v-if="visiblePosts.length < spofaqPosts.length"
				@click="visiblePostsCount = visiblePostsCount + defaultPostsPerPage"
			>
				{{ wpData.more_text }}
			</a>
		</div>
		<!-- End Search Results -->
	</div>
</template>

<script>
import WpApi from "./services/WpApi";
import Categories from "./components/Categories";
import Posts from "./components/Posts";
import Spinner from "./components/Spinner";
import SearchForm from "./components/SearchForm";

export default {
	name: "SearchApp",
	components: {
		Categories,
		Posts,
		Spinner,
		SearchForm,
	},
	props: {
		wpData: {
			type: Object,
		},
	},
	data: function () {
		return {
			searchTerm: "",
			statusText:
				"Søk i ofte stilte spørsmål ved å skrive i feltet over. Skriv minst 3 tegn for å starte søket.",
			status: "ready",
			spofaqPosts: [],
			categories: [],
			spofaqSelectedCategory: null,
			spofaqTotalMatches: 0,
			visiblePostsCount: parseInt(this.wpData.posts_per_page),
			defaultPostsPerPage: parseInt(this.wpData.posts_per_page),
		};
	},
	mounted() {
		// get all categories and reset count
		this.status = "searching";
		WpApi.queryCategories(this.wpData.rest_url).then((response) => {
			if (response !== null) {
				this.categories = response;
				this.categories.forEach(function (element) {
					element.count = 0;
				});
				this.status = "ready";
			} else {
				this.status = "ready";
			}
		});
	},
	computed: {
		visiblePosts() {
			return this.visiblePostsCount
				? this.spofaqPosts.slice(0, this.visiblePostsCount)
				: this.spofaqPosts;
		},
	},
	methods: {
		getPosts() {
			// no searching below threshold and reset everything.
			if (this.searchTerm.length < 3) {
				this.categories.forEach(function (element) {
					element.count = 0;
				});
				this.spofaqPosts = [];
				this.spofaqSelectedCategory = null;
				this.statusText = "Søk i ofte stilte spørsmål ved å skrive i feltet over. Skriv minst 3 tegn for å starte søket.";
				this.status = "ready";
				return;
			}

			this.status = "searching";
			WpApi.queryPosts(this.wpData.rest_url, 1, this.searchTerm, this.wpData.posts_per_page).then(
				(response) => {
				if (response === "Canceled") {
					this.status = "searching";
				} else if (response !== null) {
					// We got a response - get categories for given search temer
					WpApi.queryCategoriesForSearchTerm(
						this.wpData.rest_url,
						this.searchTerm
					).then((responseCategories) => {
						// update category count for the given posts
						if (responseCategories && responseCategories !== 'Canceled') {
							this.categories = categoryCounter(this.categories,responseCategories);
						}
						this.spofaqSelectedCategory = null;
						
						if (this.searchTerm.length >= 3) {
							this.parseResponse(response);
						}
					});
				} else {
					this.statusText = this.wpData.error_status_text;
					this.status = "ready";
				}
			});
		},

		getPostsForCategory(cat) {
			this.spofaqSelectedCategory = cat.id;
			this.status = "searching";

			WpApi.queryPostsByCategory(
				this.wpData.rest_url,
				1,
				this.searchTerm,
				this.wpData.posts_per_page,
				this.spofaqSelectedCategory
			).then((response) => {
				if (response === "Canceled") {
					this.status = "searching";
				} else if (response !== null) {
					this.parseResponse(response);
				} else {
					this.statusText = this.wpData.error_status_text;
					this.status = "ready";
				}
			});
		},

		parseResponse(response) {
			this.visiblePostsCount = parseInt(this.wpData.posts_per_page); // reset posts count
			this.spofaqTotalMatches = response.length;
			this.spofaqPosts = response;
			// put sticky posts on top
			this.spofaqPosts.sort(function (a, b) {
				return (
					b.meta["spofaq-sticky-checkbox"] - a.meta["spofaq-sticky-checkbox"]
				);
			});
			this.statusText =
				this.wpData.results_status_text +
				"<span>  " +
				this.spofaqTotalMatches +
				" " +
				this.wpData.matches_text +
				(this.spofaqPosts.length > 0 ? "</span>:" : ".");
			this.status = "ready";
		},
	},
};

/**
 * Count the number of matches for each given category for a search query
 */
function categoryCounter(categories, apiResponse) {
	let updatedCategories = [...categories];
	updatedCategories.forEach(function (category) {
		if (apiResponse) {
			let sum = apiResponse.reduce(function (n, respObj) {
				let sum2 = respObj.spofaq_category.reduce(function (n, cat) {
					return n + (cat == category.id);
				}, 0);
				return n + sum2;
			}, 0);

			category.count = sum;
		}
	});
	return updatedCategories;
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.spofaq-searchapp {
	position: relative;
}
</style>
